/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    PaymentCard,
    PaymentCardFromJSON,
    PaymentCardFromJSONTyped,
    PaymentCardToJSON,
} from './PaymentCard';
import {
    PaymentSourceObjectType,
    PaymentSourceObjectTypeFromJSON,
    PaymentSourceObjectTypeFromJSONTyped,
    PaymentSourceObjectTypeToJSON,
} from './PaymentSourceObjectType';
import {
    PaymentSourceStatus,
    PaymentSourceStatusFromJSON,
    PaymentSourceStatusFromJSONTyped,
    PaymentSourceStatusToJSON,
} from './PaymentSourceStatus';
import {
    PaymentSourceType,
    PaymentSourceTypeFromJSON,
    PaymentSourceTypeFromJSONTyped,
    PaymentSourceTypeToJSON,
} from './PaymentSourceType';
import {
    PaymentSourceUsage,
    PaymentSourceUsageFromJSON,
    PaymentSourceUsageFromJSONTyped,
    PaymentSourceUsageToJSON,
} from './PaymentSourceUsage';

/**
 * 
 * @export
 * @interface PaymentSource
 */
export interface PaymentSource {
    /**
     * 
     * @type {string}
     * @memberof PaymentSource
     */
    id: string;
    /**
     * 
     * @type {PaymentSourceObjectType}
     * @memberof PaymentSource
     */
    object: PaymentSourceObjectType;
    /**
     * 
     * @type {PaymentCard}
     * @memberof PaymentSource
     */
    card: PaymentCard;
    /**
     * 
     * @type {Date}
     * @memberof PaymentSource
     */
    created: Date;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof PaymentSource
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {PaymentSourceType}
     * @memberof PaymentSource
     */
    type: PaymentSourceType;
    /**
     * 
     * @type {PaymentSourceStatus}
     * @memberof PaymentSource
     */
    status: PaymentSourceStatus;
    /**
     * 
     * @type {PaymentSourceUsage}
     * @memberof PaymentSource
     */
    usage: PaymentSourceUsage;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentSource
     */
    is_default: boolean;
}

export function PaymentSourceFromJSON(json: any): PaymentSource {
    return PaymentSourceFromJSONTyped(json, false);
}

export function PaymentSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': PaymentSourceObjectTypeFromJSON(json['object']),
        'card': PaymentCardFromJSON(json['card']),
        'created': (new Date(json['created'])),
        'currency': CurrencyCodeFromJSON(json['currency']),
        'type': PaymentSourceTypeFromJSON(json['type']),
        'status': PaymentSourceStatusFromJSON(json['status']),
        'usage': PaymentSourceUsageFromJSON(json['usage']),
        'is_default': json['is_default'],
    };
}

export function PaymentSourceToJSON(value?: PaymentSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': PaymentSourceObjectTypeToJSON(value.object),
        'card': PaymentCardToJSON(value.card),
        'created': (value.created.toISOString()),
        'currency': CurrencyCodeToJSON(value.currency),
        'type': PaymentSourceTypeToJSON(value.type),
        'status': PaymentSourceStatusToJSON(value.status),
        'usage': PaymentSourceUsageToJSON(value.usage),
        'is_default': value.is_default,
    };
}

